import { Loader } from 'rsuite';
import { useAuthRedirect } from '../../hooks/useAuthRedirect';

export default function IndexPage() {
    useAuthRedirect();

    return (
        <div className='loader-container'>
            <Loader size='lg' />
        </div>
    );
}
